/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_2_DInputs */

const en_cp_who_2_d = /** @type {(inputs: Cp_Who_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join as a client viewer without opening a repo: see each team's progress and evidence, approve phases as process assessment. The approval log is an objective record of who did what, when.`)
};

const id_cp_who_2_d = /** @type {(inputs: Cp_Who_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk sebagai client viewer tanpa membuka repo: lihat progres tiap tim, bukti tiap task, dan setujui fase sebagai penilaian proses. Log persetujuan jadi catatan objektif siapa mengerjakan apa dan kapan.`)
};

/**
* | output |
* | --- |
* | "Join as a client viewer without opening a repo: see each team's progress and evidence, approve phases as process assessment. The approval log is an objective..." |
*
* @param {Cp_Who_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_2_d = /** @type {((inputs?: Cp_Who_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_2_d(inputs)
	return en_cp_who_2_d(inputs)
});